<template>
  <div class="burgerMenu" :class="{ open: $store.state.isOpenBurgerMenu }">
    <div class="burgerMenu-wrapper" v-click-outside="close">
      <div class="burgerMenu-wrapper__header">
        <p class="burgerMenu-wrapper__header-title">
          {{ $t('navigation.title') }}
        </p>
        <Icon class="burgerMenu-wrapper__header-close" name="/burgerMenu/close.svg" alt="Close" @click="close" />
      </div>
      <div class="burgerMenu-wrapper__content">
        <ul class="burgerMenu-wrapper__content-list">
          <template v-for="(item, index) in menuList">
            <li v-if="item.title" class="burgerMenu-wrapper__content-list__item" :key="`menu-${index}`" @click="close">
              <Icon v-if="item.icon" :name="item.icon" />
              <router-link v-if="item.url" :to="item.url">
                {{ item.title }}
              </router-link>
              <a v-if="item.callback" href="#" @click.prevent="item.callback">{{ item.title }}</a>
            </li>
            <li v-else class="divider-line" :key="`menu-${index}`" />
          </template>

          <li class="divider-line" />

          <li v-if="isAuth" class="burgerMenu-wrapper__content-list__item">
            <Icon name="/SignIn/logout.svg" />
            <a href="#" @click.prevent="$store.dispatch('logOut')">
              {{ $t('navigation.dropdown.logout') }}
            </a>
          </li>
        </ul>
      </div>

      <div class="burgerMenu-wrapper__footer">
        <a :href="vkUrl" target="_blank" v-if="$store.getters.language === 'ru'">
          <Icon name="/help/vk.svg" alt="" />
        </a>
        <a :href="tgUrl" target="_blank">
          <Icon name="/help/telegram.svg" alt="" />
        </a>
        <a :href="youtubeUrl" target="_blank">
          <Icon name="/help/youtube.svg" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import windowSize from '@/mixins/windowSize'
import Icon from '@/components/Base/Icon/Icon.vue'
import social from '@/mixins/social'
import { openChat } from '@/utils/chat'
import { copyText } from '@/utils/copyText'
import { PURCHASE_PATHS } from '@/utils/purchase'
import { clickOutside } from '@/directives/clickOutside'

export default {
  name: 'BurgerMenu',
  mixins: [windowSize, social],
  directives: {
    clickOutside
  },
  components: {
    Icon
  },
  computed: {
    ...mapGetters(['language', 'isAuth', 'isPacksAvailable']),
    isRussian() {
      return this.language === 'ru'
    },
    menuList() {
      return [
        { title: this.$t('navigation.buyRobux'), icon: '/base/transfer.svg', url: { path: PURCHASE_PATHS.transfer } },
        {
          title: this.$t('navigation.gift'),
          icon: '/base/gift.svg',
          url: { path: PURCHASE_PATHS.gift }
        },
        {
          title: this.$t('navigation.superPass'),
          icon: '/base/super-pass.svg',
          url: { path: PURCHASE_PATHS.superPass }
        },
        {
          title: this.$t('navigation.packs'),
          icon: '/base/package.svg',
          url: { path: PURCHASE_PATHS.packs },
          // Логпасс может быть выключен у поставщика — тогда пункта нет.
          hidden: !this.isPacksAvailable
        },
        { title: '', auth: true },
        { title: this.$t('app.titlePostfix.payment'), icon: '/base/wallet.svg', url: { path: '/payment' }, auth: true },
        {
          title: this.$t('navigation.dropdown.history'),
          icon: '/base/profile.svg',
          url: { path: '/history' },
          auth: true
        },
        { title: '', auth: true },
        {
          title: this.$t('navigation.dropdown.copyId'),
          icon: '/base/copy.svg',
          callback: () => this.copyId(),
          auth: true
        },
        { title: this.$t('supportChat.titleSm'), icon: '/base/support.svg', callback: () => this.openChat() }
      ].filter(item => (!item.auth || this.isAuth) && !item.hidden)
    }
  },
  watch: {
    screenWidth(value) {
      if (value > 965) {
        this.$store.state.isOpenBurgerMenu = false
        this.close()
      }
    }
  },
  methods: {
    openChat,
    copyId() {
      copyText(this.$store.state.account.userId)
    },
    close() {
      this.$store.state.isOpenBurgerMenu = false
    }
  }
}
</script>

<style lang="scss">
@import './burgermenu';
</style>
